import React from "react";
import Navbar from "react-bootstrap/Navbar";
import PrimaryLogo from "../../assets/images/Primary_Logo.png";

const Header = () => {
  return (
    <Navbar bg="light">
      <Navbar.Brand href="https://www.codeyoung.com/">
        <img
          src={PrimaryLogo}
          alt="Primary_Logo"
          width="150"
          height="50"
          className="d-inline-block align-top"
        />
      </Navbar.Brand>
    </Navbar>
  );
};

export default Header;
